export default __webpack_public_path__ + "static/media/close.825df35a.svg";